<div *ngIf="isSettingsRoute" class="child-setting-header details-heading mb-2">
  <div class="title-wrapper text-truncate mr-2">
    <app-back-button [url]="':accountId/settings/documents-manager' | url"></app-back-button>
    <div class="child-setting-header-title">
      {{ T.settings.document_manager | translate }}<i class="material-symbols-outlined">keyboard_arrow_right</i>
      {{ getTitle() }}
    </div>
  </div>
</div>

<ng-container *ngIf="!loading">
  <div *ngIf="isDetailsPage">
    <div>
      <app-attachments-board-view
        [documents]="objects"
        [accountId]="accountId"
        [uploadViewModel]="uploadViewModel"
        (onAttachmentDownload)="attachmentDownload($event)"
        (onAttachmentDelete)="deleteDocument($event)"
      ></app-attachments-board-view>
    </div>
    <div>
      <app-upload-container
        [globalObjectId]="0"
        [disableDragAndDrop]="disableDragAndDrop"
        (onFilesAdded)="addFiles($event)"
        (onLinkAdded)="addLink()"
      ></app-upload-container>
    </div>
  </div>
  <div *ngIf="!isDetailsPage && !documentCategoriesRoute && objects" class="content-wrapper">
    <input
      #file
      type="file"
      [name]="'file-' + objectId"
      class="inputfile"
      (change)="onSelectFile(file.files)"
      (click)="$event.target.value = null"
    />
    <div class="documents-list-wrapper">
      <div style="display: flex; position: relative" class="header">
        <app-button-rectangle
        #uploadAction
        size="small"
        icon="upload"
        [text]="T.common.upload_document | translate"
        buttonTheme="white"
        [disabled]="!canEdit"
        [ngClass]="{ disabled: !canEdit }"
        class="mb-3 w-100"
        [fitToContainer]="true"
        (clicked)="showUploadOptions()"
      ></app-button-rectangle>
      </div>
      <app-attachments-board-view
        [documents]="objects"
        [accountId]="accountId"
        [uploadViewModel]="uploadViewModel"
        [contextualInfo]="contextualInfo"
        (onAttachmentDownload)="attachmentDownload($event)"
        (onAttachmentDelete)="deleteDocument($event)"
      ></app-attachments-board-view>
    </div>
  </div>
  <ng-container *ngIf="!isDetailsPage && !objects && canEdit">
    <app-upload-container
      [globalObjectId]="0"
      [disableDragAndDrop]="disableDragAndDrop"
      (onFilesAdded)="addFiles($event)"
      (onLinkAdded)="addLink()"
    ></app-upload-container>
  </ng-container>

  <div *ngIf="documentCategoriesRoute" class="content-wrapper">
    <div class="documents-list-wrapper">
      <div style="display: flex; position: relative" class="header">
        <app-list-header
          [showSearchBar]="false"
          [showRAGBreakdown]="false"
          [searchPlaceholder]="T.common.search_item | translate: { item: T.common.category.one | translate }"
          (onSearch)="onCategorySearch($event)"
        >
          <app-button-rectangle *ngIf="canEdit"
            (click)="addDocumentCategory()"
            [text]="T.common.add_item | translate: { item: T.defaultLocalizations.document_category.one | translate }"
            size="small"
            icon="add"
            buttonTheme="white"
            class="mr-8"
          ></app-button-rectangle>
        </app-list-header>
        <app-button-rectangle *ngIf="canEdit"
          [icon]="'delete'"
          [ngClass]="{ disabled: !documentCategoryDeleteButtonEnabled }"
          [disabled]="!documentCategoryDeleteButtonEnabled "
          size="small"
          buttonTheme="white"
          class="mt-8"
          [text]="T.common.delete_item | translate: { item: T.common.category.one | translate }"
          (click)="$event.stopPropagation()"
          (click)="deleteCategory(selectedCategoriesArray)"
        ></app-button-rectangle>
      </div>
      <ng-container *ngIf="documentObjects">
        <app-responsive-table
          [objects]="documentObjects"
          [selectedObjects]="selectedCategoriesArray"
          [tableHeaders]="categoriesTableHeaders()"
          [wholeRowSelection]="false"
          [adoptParentHeight]="false"
          [useSearch]="false"
          [searchSubject]="searchSubject"
          [selectableObjects]="canEdit"
          (objectsSelected)="selectedCategories($event)"
          (objectClicked)="onCategoryClicked($event)"
        ></app-responsive-table>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="loading">
  <app-loading></app-loading>
</ng-container>
